export default __webpack_public_path__ + "pgnv-assets/b932499b2a7a0d2f856717eab441bf74.png";